import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { joiResolver } from '@hookform/resolvers/joi';

import { useAppContext } from '../../../../../app/Context';
import { updatePoll } from '../../../../../db/polls';
import { usePollContext } from '../../../Context';
import { FormValues } from './types';
import { finalValidationSchema, validationSchema } from './validators';

export interface UsePollTitleForm {
  shouldUseRequiredValidator: boolean;
}

const usePollTitleForm = ({ shouldUseRequiredValidator }: UsePollTitleForm) => {
  const { isPresenting } = useAppContext();
  const { poll, setPoll } = usePollContext();

  const formMethods = useForm<FormValues>({
    resolver: (values, ...args) => {
      if (isPresenting || shouldUseRequiredValidator) {
        return joiResolver(finalValidationSchema)(values, ...args);
      }
      return joiResolver(validationSchema)(values, ...args);
    },
    defaultValues: {
      title: '',
    },
    mode: 'all',
  });

  const { setValue } = formMethods;

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    if (!poll?.id) return;

    updatePoll({
      classId: poll.classId,
      pollId: poll.id,
      title: data.title,
      isAnonymous: poll.preferences.isAnonymous,
    });
  };

  const onLocalSubmit: SubmitHandler<FormValues> = (data) => {
    if (!poll?.id) return;

    setPoll({
      ...poll,
      title: data.title,
    });
  };

  useEffect(() => {
    setValue('title', poll?.title ?? '');
  }, [setValue, poll?.title]);

  return { formMethods, onSubmit, onLocalSubmit };
};

export default usePollTitleForm;
